<template>
  <a-modal
    :visible.sync="isVisible"
    :confirmLoading="loading"
    :okButtonProps="{ props: {disabled: false} }"
    :maskClosable="false"
    :bodyStyle="isMobile() ? { margin: 'auto 20px' } : { margin: 'auto 50px' }"
    title="创建用户"
    @ok="handleOk"
    @cancel="handleCancel">
    <a-form :form="form">
      <a-form-item label="账号" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 18 }">
        <a-input
          placeholder="请输入要创建的登录名"
          v-decorator="['username', {
            rules: [{ required: true, message: '用户姓名不能为空' },
                    { pattern: /^[0-9a-z]{5,20}$/, message: '用户名必须是5-20位数字、小写字母或二者组合' }],
            validateTrigger: 'blur'
          }]">
          <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }"/>
        </a-input>
      </a-form-item>

      <a-form-item label="密码" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 18 }">
        <a-input
          type="password"
          autocomplete="false"
          placeholder="请输入8-20位密码"
          v-decorator="['password', {
            rules: [{ required: true, message: '请输入密码' },
                    { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/, message: '密码必须是8-20位数字与字母的组合' }],
            validateTrigger: 'blur'
          }]">
          <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }"/>
        </a-input>
      </a-form-item>

      <a-form-item label="重复密码" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 18 }">
        <a-input
          type="password"
          autocomplete="false"
          placeholder="重复新密码"
          v-decorator="['repeatPass', {
            rules: [{ required: true, message: '请重复输入密码' }, { validator: handleRepeatPass }],
            validateTrigger: 'blur'
          }]">
          <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }"/>
        </a-input>
      </a-form-item>

      <a-form-item label="角色" :labelCol="{ span: 5 }" :wrapperCol="{ span: 17 }">
        <a-select
          mode="multiple"
          placeholder="请选择角色"
          style="width:100%;"
          v-decorator="[ 'roles', { rules: [{ required: true, message: '至少选择一种角色' }] } ]">
          <a-select-option v-for="role in roles" :key="role">
            {{ role }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item v-show="isAdmin" label="所属企业" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 18 }">
        <a-select
          placeholder="键入名字选择企业"
          :filterOption="false"
          showSearch
          @search="loadCorps"
          :notFoundContent="corpLoading ? undefined : '没有符合的企业'"
          v-decorator="['corp', {
            rules: [{ required: true, message: '企业不能为空' }]
          }]">
          <a-spin v-if="corpLoading" slot="notFoundContent" size="small"/>
          <a-select-option v-for="item in corps" :key="item.id">{{ item.name }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="姓名" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 18 }">
        <a-input
          placeholder="输入用户姓名"
          v-decorator="['realname', {
            rules: [{ required: true, message: '用户姓名不能为空' },
                    { pattern: /^([\u4E00-\uFA29]|[\uE7C7-\uE7F3]|[a-zA-Z]){2,20}$/, message: '姓名限制2-20个中英文字符' }],
            validateTrigger: 'blur'
          }]"/>
      </a-form-item>

      <a-form-item label="手机号码" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 18 }">
        <a-input
          placeholder="输入手机号码"
          v-decorator="['mobile', {
            rules: [{ required: true, pattern: /^1[34578]\d{9}$/, message: '请输入正确的手机号码' }]
          }]"/>
      </a-form-item>

      <a-form-item label="邮箱" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 18 }">
        <a-input
          placeholder="输入邮箱"
          v-decorator="['email', {
            rules: [{ required: true, type: 'email', message: '请输入正确的邮箱地址' }]
          }]"/>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { createUser } from '@/api/user'
import { pageCorp } from '@/api/corp'
import { encryptPsw } from '@/utils/util'
import { mixinDevice } from '@/utils/mixin'

export default {
  mixins: [mixinDevice],

  props: {
    visible: {
      required: true,
      type: Boolean
    },

    roles: {
      required: true,
      type: Array
    },

    isAdmin: {
      required: true,
      type: Boolean
    },

    corpId: {
      required: false,
      type: String,
      default: ''
    }
  },

  data () {
    return {
      form: this.$form.createForm(this),
      loading: false,
      corpLoading: false,
      corps: []
    }
  },

  computed: {
    isVisible: {
      get: function () {
        return this.visible
      },
      set: function (val) {
        this.$emit('update:visible', val)
      }
    }
  },

  methods: {
    onLoad () {
      this.form.resetFields()
      this.loadCorps()
      if (!this.isAdmin) {
        this.$nextTick(() =>
          this.form.setFieldsValue({ 'corp': this.corpId })
        )
      }
    },

    handleOk () {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          values.password = encryptPsw(values.password)
          values.repeatPass = null // 无需提交
          values.corpId = values.corp
          values.corp = null // 无需提交
          createUser(values).then(response => {
            this.$message.success(response.msg)
            this.isVisible = false
            this.$emit('onCreated')
          }).catch(err => {
            console.log(err)
          }).finally(() => {
            this.loading = false
          })
        } else {
          console.log(err)
          this.loading = false
        }
      })
    },

    handleCancel () {
      this.isVisible = false
    },

    handleRepeatPass (rule, value, callback) {
      const { getFieldValue } = this.form
      if (value && value !== getFieldValue('password')) {
        callback('两次输入的密码不一致！')
      }
      callback() // Note: 必须总是返回一个 callback，否则 validateFieldsAndScroll 无法响应
    },

    loadCorps (val) {
      this.corpLoading = true
      const query = {
        name: val,
        pageSize: 50,
        pageNumber: 0
      }
      pageCorp(query).then(response => {
        this.corps = response.data.content
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.corpLoading = false
      })
    }
  }
}
</script>

<style scoped>
</style>
